<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" xl="2" lg="2" md="3" sm="12" v-if="mobile">
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-title class="subtitle-2">
                Stake
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ formatCurrency(bet.stake) }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="subtitle-2">
                Bot
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ bet.bot }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="bet.final">
              <v-list-item-title class="subtitle-2">
                Margin
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ formatPercentage(bet.margin, 0) }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="bet.final">
              <v-list-item-title class="subtitle-2">
                EV
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ formatCurrency(bet.ev) }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="3" sm="12">
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-title class="subtitle-2">
                Code
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ formatRaceType(bet.race_type) }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="subtitle-2">
                Selection
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ bet.selection }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="subtitle-2">
                Market
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ formatMarketType(bet.market_type) }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="12">
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-title class="subtitle-2"
                >Back Odds</v-list-item-title
              >

              <v-list-item-subtitle class="text-right">
                {{ bet.back_odds }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="subtitle-2"
                >Betfair Odds</v-list-item-title
              >

              <v-list-item-subtitle class="text-right">
                {{ bet.betfair_odds.toFixed(2) }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="bet.bsp">
              <v-list-item-title class="subtitle-2">
                BSP
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ bet.bsp.toFixed(2) }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-else-if="bet.reject_reason">
              <v-list-item-title class="subtitle-2">
                Reject Reason
              </v-list-item-title>

              <v-list-item-subtitle
                class="text-right"
                style="white-space: pre-wrap;"
              >
                {{ bet.reject_reason }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="3" sm="12">
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-title class="subtitle-2 before-jump">
                Bet ID
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ this.bet.id }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="bet.transaction_id">
              <v-list-item-title class="subtitle-2 before-jump">
                Bookie ID
              </v-list-item-title>

              <v-list-item-subtitle
                class="text-right"
                :title="this.bet.transaction_id"
              >
                {{ this.bet.transaction_id }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="caption">
                <a :href="bet.bookie_url" rel="noreferrer" target="_blank">
                  Bookie Link
                </a>
              </v-list-item-title>

              <v-list-item-title class="caption text-right">
                <a :href="bet.betfair_url" rel="noreferrer" target="_blank">
                  Betfair Link
                </a>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="showRejectMessage">
              <v-list-item-title class="subtitle-2">
                Reject Message
              </v-list-item-title>

              <v-list-item-subtitle
                class="text-right"
                style="white-space: pre-wrap;"
              >
                {{ bet.reject_message }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="12">
        <v-card flat>
          <v-list>
            <v-list-item v-if="betProcessed">
              <v-list-item-title class="subtitle-2 before-jump">
                Time Before Jump
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ timeBeforeJump }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="betProcessed">
              <v-list-item-title class="subtitle-2 before-jump">
                Placement Time
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ this.formatDuration(bet.placement_time) }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="betProcessed">
              <v-list-item-title class="subtitle-2 before-jump">
                Processing Time
              </v-list-item-title>

              <v-list-item-subtitle class="text-right">
                {{ this.formatDuration(bet.processing_time) }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" xl="2" lg="2" md="3" sm="12" v-if="mobile">
        <v-card flat class="d-flex justify-center align-center">
          <v-btn
            x-small
            color="primary"
            :ripple="false"
            @click.stop="requestScreenshots()"
          >
            Request Screenshots
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import {
  currency,
  percentage,
  duration,
  marketType,
  raceType
} from "../lib/formatting";
import { screenshotBet } from "../lib/commands";

export default {
  name: "BetExpanded",
  props: ["bet", "mobile"],
  methods: {
    formatRaceType: raceType,
    formatMarketType: marketType,
    formatCurrency: currency,
    formatPercentage: percentage,
    formatDuration: duration,
    async requestScreenshots() {
      try {
        debugger;
        const resp = await screenshotBet(
          this.bet.bot,
          moment(this.bet.date).format("YYYY-MM-DD"),
          this.bet.bookie,
          this.bet.id
        );
        if (resp.no_response) {
          this.showError("No response received from bot");
        } else {
          this.showSuccess("Screenshots sent");
        }
      } catch (err) {
        this.showError(err);
      }
    }
  },
  computed: {
    betProcessed() {
      return (
        this.bet.state === "FINAL" ||
        this.bet.state === "ACCEPTED" ||
        this.bet.state === "REJECTED"
      );
    },
    showRejectMessage() {
      return (
        this.bet.reject_message &&
        (this.bet.reject_reason === "DECLINED" ||
          this.bet.reject_reason === "UNKNOWN" ||
          this.bet.reject_reason === "EXPECTED_VALID_ERROR" ||
          this.bet.reject_reason === "EXCEED_MAX_STAKE" ||
          this.bet.reject_reason === "PRICE_CHANGE" ||
          this.bet.reject_reason === "UNEXPECTED_ISSUE")
      );
    },
    timeBeforeJump() {
      const diff = moment.duration(
        moment(this.bet.race_start_time).diff(moment(this.bet.date))
      );

      if (diff.minutes() === 0) {
        return `${diff.seconds()}s`;
      }

      return `${diff.minutes()}m ${Math.abs(diff.seconds())}s`;
    }
  }
};
</script>

<style lang="scss">
.before-jump {
  overflow: visible;
}
</style>
